import { component } from "picoapp";

export default component(async (node, ctx) => {
  const { default: Player } = await import("@vimeo/player");

  const playerId = node.querySelector(".js-video");

  if (playerId) {
    const player = new Player(playerId.id, {
      id: playerId.dataset.id,
      controls: false,
      height: playerId.dataset.height,
      muted: true,
      loop: true,
      autoplay: true,
      background: true,
    });

    player.on("loaded", () => {
      // data is an object  containing properties specific to that event
      setTimeout(() => playerId.classList.remove("pdp-video--hidden"), 2000);

      player.play();
    });
  }
});
